import { render, staticRenderFns } from "./costHelpSixtyTage.vue?vue&type=template&id=add983e8&"
import script from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('add983e8')) {
      api.createRecord('add983e8', component.options)
    } else {
      api.reload('add983e8', component.options)
    }
    module.hot.accept("./costHelpSixtyTage.vue?vue&type=template&id=add983e8&", function () {
      api.rerender('add983e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-270j5iEt9DSqh/JS/costHelpSixtyTage.vue"
export default component.exports